<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            admin: 'auth/getAdmin',
        })
    },

    methods: {
        ...mapActions({
            signOut: 'auth/signOut',
        }),

        ...mapMutations({
            setOverlay: 'termReports/setProgressOverlay',
            setStep: 'auth/setStep',            
        }),
        

        async logOut () {            
            this.setOverlay(true);
            this.setStep(1);            
            await this.signOut();
            this.setOverlay(false);
            //console.log("logout complete");
            if(this.admin) {
                this.$router.replace('/admin');
                return;
            }
            this.$router.replace('/')
        }

        
    }
}
</script>